import React, { useState, useEffect, useRef } from 'react';

export const InfoTooltip = ({ text }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const tooltipRef = useRef(null);

  // Fermer le tooltip au clic en dehors sur mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setIsTooltipVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative ml-1" ref={tooltipRef}>
      <div
        className="cursor-help w-4 h-4 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-xs text-gray-600 dark:text-gray-300"
        onClick={() => setIsTooltipVisible(!isTooltipVisible)}
        onMouseEnter={() => setIsTooltipVisible(true)}
        onMouseLeave={() => setIsTooltipVisible(false)}
      >
        i
      </div>
      {isTooltipVisible && (
        <div className="absolute z-10 w-64 p-2 bg-white dark:bg-gray-800 text-xs text-gray-700 dark:text-gray-300 rounded shadow-lg border border-gray-200 dark:border-gray-700 left-0 transform -translate-x-1/2 top-5">
          {text}
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;